import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { LIST_TENANT_USERS_QUERY_KEY } from './useFetchTenantUsers';

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const { mutate, isPending, error } = useMutation({
    mutationFn: (userId: string) => api.users.deleteUser(tenantId, userId),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [LIST_TENANT_USERS_QUERY_KEY], exact: false });
    },
  });

  return {
    mutate,
    isPending,
    error: error as AxiosError<{ message: string }>,
  };
};
